import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

const useOrgDesignStore = create(
  devtools(
    persist(
      (set, get) => ({
        savedVersions: [],
        draft: null,
        activeLoadToken: null,

        setDraft: (draft) => set({ draft }),

        // Claimed by any action about to load a genuinely new draft
        // (startFromExistingOrg, startFromPaicGenerated, openVersion) — an
        // async loader checks isActiveLoad after awaiting its response, so a
        // slower/older request can never overwrite whatever newer draft has
        // since been loaded.
        claimLoad: () => {
          const token = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
          set({ activeLoadToken: token });
          return token;
        },
        isActiveLoad: (token) => get().activeLoadToken === token,

        saveDraftAsVersion: (label) => {
          const { draft, savedVersions } = get();
          if (!draft) return null;
          const entry = {
            versionId: `v-${Date.now()}`,
            label: label || `v${savedVersions.length + 1}`,
            createdAt: new Date().toISOString(),
            createdBy: "You",
            entryOption: draft.entryOption,
            sourceLabel: draft.sourceLabel,
            asIsHc: draft.stats.as_is_hc,
            totalAfterHc: draft.stats.total_after_hc,
            status: "Saved",
            snapshot: draft,
          };
          set({ savedVersions: [entry, ...savedVersions] });
          return entry;
        },
      }),
      {
        name: "org-design-store",
        // Only the in-progress draft and local saved-version snapshots
        // survive a refresh/crash — activeLoadToken is a load-in-flight
        // marker that must start fresh every session, not a value that
        // should ever be replayed from storage.
        partialize: (state) => ({
          draft: state.draft,
          savedVersions: state.savedVersions,
        }),
      }
    ),
    { name: "OrgDesignStore" }
  )
);

export default useOrgDesignStore;
